export default __webpack_public_path__ + "static/media/japan_jica.282e7664.png";